module.exports = __webpack_public_path__ + "img/5.e5cf5d82.svg";